// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"6e6efc72adf191d53dbc","454":"8acfb84d23c9e1caea33"}[chunkId] + ".js";
};